import {Signal} from 'typed-signals';

import {debounce} from '@helpers/utils'
import {MediaQuery} from '@services/MediaQuery';
import {Orientation} from '@services/types';

export class OrientationService {
  static singleton: OrientationService;

  public onChange = new Signal<(orientation: Orientation) => void>();
  private mq = MediaQuery.create();
  private initialWidth = 0;
  private initialHeight = 0;
  private orientationChangeWidth = 0;
  private orientationChangeHeight = 0;

  static create() {
    if (OrientationService.singleton) {
      return OrientationService.singleton;
    }
    return (OrientationService.singleton = new OrientationService());
  }

  constructor() {
    if (this.mq.isDesktop()) {
      return;
    }
    this.initialWidth = window.innerWidth;
    this.initialHeight = window.innerHeight;
    window.addEventListener(
      'orientationchange',
      this.changeOrientation.bind(this),
    );
    window.addEventListener(
      'resize',
      debounce(this.changeOrientation.bind(this), 100),
    );

    this.preventDefaultHandler = this.preventDefaultHandler.bind(this);
  }

  // TODO: こんなんでいいのか・・・・
  get orientation() {
    return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  }

  /**
   * android 対応
   * 参考サイト(下記のJSは動かないので独自で実装)
   * https://github.com/tomoyuki-wada/jquery.orientation_lib/blob/master/document(jp).md
   */
  private changeOrientation() {
    this.orientationChangeWidth = window.innerWidth;
    this.orientationChangeHeight = window.innerHeight;

    if (this.orientationChangeWidth !== this.initialWidth) {
      this.initialWidth = this.orientationChangeWidth;
      this.onChange.emit(this.orientation);
    }
    if (this.orientationChangeHeight !== this.initialHeight) {
      this.initialHeight = this.orientationChangeHeight;
    }
  }

  private preventDefaultHandler(e: Event) {
    e.preventDefault();
  }
}
